import { t } from "i18next";

type LanguageEntry = {
  label: string;
  flag: string;
};

type Languages = {
  [key: string]: LanguageEntry;
};

const alFlag = require("../assets/images/flags/al.jpg");
const usFlag = require("../assets/images/flags/us.jpg");


const languages: Languages = {
  al: {
    label: t('Albanian_lng'),
    flag: alFlag,
  },
  en: {
    label: t('English_lng'),
    flag: usFlag,
  },
};

export default languages;
